// The backend's voucher PDF endpoints answer with `Content-Disposition: attachment`
// unless `disposition=inline` is asked for. Opening the plain URL in a new tab
// therefore starts a download and leaves an empty tab behind instead of showing the
// document — so every "open/view" path has to ask for `inline` explicitly. Download
// buttons keep the default.
export const inlinePdfUrl = url => `${url}${url.includes('?') ? '&' : '?'}disposition=inline`;
